import React from "react";
import { birthDateFormat } from "../../utils/helpers";

function ChildBirthDate(props) {
  const { dateVal } = props;
  const parseDateValStr = str => {
    const parseDateStr = /(\d{4})-?(\d{2})-?(\d{2})/;
    const [fullStr, year, month, day] = parseDateStr.exec(str) || [];
    return (fullStr && [month, day, year].join("/")) || str;
  };

  const birthDateFormat = (dateVal) => {
    // Format like: JUN 13TH, 2009
    const date = new Date(parseDateValStr(dateVal));
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const monthShortName = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'][monthIndex];
    const dateIndex = date.getDate();
    const places = { "th": /([4-9]|0|11|12|13)$/, "st": /1$/, "nd": /2$/, "rd": /3$/};
    const getDayTH = (num) => (num + Object.keys(places).find(val => places[val].test(num)) || "");
    const dateTH = getDayTH(dateIndex);
    const birthDateFormatStr = `${monthShortName} ${dateTH}, ${year}`.toUpperCase();
    
    return [birthDateFormatStr, date];
  };
  const [birthDateFormatStr, date] = birthDateFormat(dateVal);

  return (
    <time className="ChildBirthDate" dateTime={date.getTime()}>{birthDateFormatStr}</time>
  );
}

export default ChildBirthDate;